import { combineReducers } from "redux";
import { AuthReducer, UserDataReducer, UserSessionDataReducer } from "./features"; // also don't forget to register redux-form
// recommend to register under state.app

export const combineAppReducer = reducers => {
  return combineReducers({ ...reducers,
    auth: AuthReducer,
    localUserData: UserDataReducer,
    sessionUserData: UserSessionDataReducer
  });
};